<header class="header" [class.scrolled]="scrolled" id="mainHeader">
  <div class="header-inner">
    <button
      class="menu-toggle"
      (click)="toggleMobileMenu()"
      [attr.aria-expanded]="mobileMenuOpen"
      aria-label="Toggle menu"
      id="menuToggle"
    >
      <span class="menu-toggle-bar" [class.open]="mobileMenuOpen"></span>
      <span class="menu-toggle-bar" [class.open]="mobileMenuOpen"></span>
      <span class="menu-toggle-bar" [class.open]="mobileMenuOpen"></span>
    </button>
    <a routerLink="/" (click)="navigateToHome($event)" class="logo">
      <img
        [src]="
          isDarkMode
            ? 'assets/images/LIVEPASS-w.png'
            : 'assets/images/LIVEPASS-b.png'
        "
        alt="EventHub Live"
        class="logo-img"
        width="140"
        height="32"
      />
    </a>
    <nav class="nav-links">
      @for (item of headerNavItems; track item.label) {
        <a
          [href]="item.href || (item.kind === 'discover' ? '/' : '/discover')"
          [class.nav-active]="isNavItemActive(item)"
          (click)="onNavClick($event, item)"
          >{{ item.label }}</a
        >
      }
      <!-- <a href="#organize">List Event</a> -->
    </nav>

    <div class="header-right">
      @if (isLoggedIn) {
        <a
          href="/cart"
          class="header-cart-btn"
          [class.header-cart-btn--has-items]="cartHasItems"
          aria-label="My cart"
          (click)="openReviewFromCartClick($event)"
        >
          <svg
            class="cart-btn"
            width="22"
            height="22"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            aria-hidden="true"
          >
            <path
              d="M6 6h15l-1.5 9h-12L6 6z"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M6 6L5 3H2"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <circle cx="9" cy="20" r="1.5" fill="currentColor" />
            <circle cx="18" cy="20" r="1.5" fill="currentColor" />
          </svg>
        </a>
      }
      @if (isLoggedIn && reviewCountdown) {
        <span
          class="header-review-timer"
          [class.header-review-timer--danger]="reviewCountdownDanger"
          aria-label="Booking hold time remaining"
          >{{ reviewCountdown }}</span
        >
      }
      <div style="position: relative">
        <button
          type="button"
          class="city-btn"
          id="cityBtn"
          (click)="openCityPickerModal()"
          aria-haspopup="dialog"
          [attr.aria-expanded]="cityPickerModalOpen"
        >
          <svg
            width="14"
            height="14"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            style="color: #f97316"
          >
            <path
              d="M21 10C21 17 12 23 12 23S3 17 3 10C3 5.02944 7.02944 1 12 1C16.9706 1 21 5.02944 21 10Z"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <circle
              cx="12"
              cy="10"
              r="3"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
          <span class="city-label city-label-full">{{ selectedCity }}</span>
          <span class="city-label city-label-short">{{ getCityShort() }}</span>
          <svg
            width="14"
            height="14"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            style="transition: transform 0.2s"
          >
            <path
              d="M6 9L12 15L18 9"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
        </button>
      </div>
      <button
        type="button"
        class="theme-toggle-btn"
        (click)="toggleTheme()"
        [attr.aria-label]="themeToggleLabel"
        [attr.title]="themeToggleLabel"
      >
        @if (isDarkMode) {
          <span aria-hidden="true">☀️</span>
        } @else {
          <span aria-hidden="true">🌙</span>
        }
      </button>
      <button
        type="button"
        class="header-search-btn"
        (click)="openSearchModal()"
        aria-label="Open search"
        [attr.aria-expanded]="searchModalOpen"
        aria-haspopup="dialog"
      >
        <svg
          width="20"
          height="20"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          aria-hidden="true"
        >
          <circle
            cx="11"
            cy="11"
            r="6"
            stroke="currentColor"
            stroke-width="2"
          />
          <path
            d="M20 20L16.65 16.65"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
          />
        </svg>
      </button>
      <!-- <button class="btn-outline list-btn" (click)="navigateToOrganizer()">List Your Event</button> -->
      @if (isLoggedIn) {
        <div style="position: relative">
          <button
            class="user-avatar-btn"
            id="userBtn"
            (click)="toggleUserDropdown()"
            [attr.aria-label]="'Account menu'"
          >
            @if (userProfile?.profile_picture; as pic) {
              <img
                [src]="pic"
                [alt]="getUserDisplayName()"
                class="user-avatar-img"
              />
            } @else if (hasNameBasedAvatar()) {
              <div class="user-avatar-initials">{{ getUserInitials() }}</div>
            } @else {
              <span class="user-avatar-icon" aria-hidden="true">
                <svg
                  width="20"
                  height="20"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M20 21V19C20 17.9391 19.5786 16.9217 18.8284 16.1716C18.0783 15.4214 17.0609 15 16 15H8C6.93913 15 5.92172 15.4214 5.17157 16.1716C4.42143 16.9217 4 17.9391 4 19V21"
                    stroke="currentColor"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <circle
                    cx="12"
                    cy="7"
                    r="4"
                    stroke="currentColor"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
              </span>
            }
          </button>
          <div class="user-dropdown" [class.open]="userDropdownOpen">
            <div class="user-dropdown-header">
              @if (userProfile?.profile_picture; as pic2) {
                <img
                  [src]="pic2"
                  [alt]="getUserDisplayName()"
                  class="user-dropdown-avatar"
                />
              } @else if (hasNameBasedAvatar()) {
                <div class="user-dropdown-initials">
                  {{ getUserInitials() }}
                </div>
              } @else {
                <span class="user-dropdown-icon" aria-hidden="true">
                  <svg
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M20 21V19C20 17.9391 19.5786 16.9217 18.8284 16.1716C18.0783 15.4214 17.0609 15 16 15H8C6.93913 15 5.92172 15.4214 5.17157 16.1716C4.42143 16.9217 4 17.9391 4 19V21"
                      stroke="currentColor"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <circle
                      cx="12"
                      cy="7"
                      r="4"
                      stroke="currentColor"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                </span>
              }
              <div class="user-dropdown-info">
                <div class="user-dropdown-name">{{ getUserDisplayName() }}</div>
                <div class="user-dropdown-email">
                  {{ getUserAccountSubtitle() }}
                </div>
              </div>
            </div>
            <div class="user-dropdown-divider"></div>
            <a
              routerLink="/profile"
              class="user-dropdown-item user-dropdown-item--profile"
              (click)="openProfileTab('profile')"
            >
              <i
                class="pi pi-user user-dropdown-item-icon"
                aria-hidden="true"
              ></i>
              <span>My Profile</span>
            </a>
            <button
              class="user-dropdown-item user-dropdown-item--orders"
              (click)="openProfileTab('orders')"
            >
              <i
                class="pi pi-file user-dropdown-item-icon"
                aria-hidden="true"
              ></i>
              <span>My Orders</span>
            </button>
            <!-- <button class="user-dropdown-item" (click)="openSavedDevices()">
              <span>💻</span>
              <span>Saved Devices</span>
            </button> -->
            <button
              class="user-dropdown-item user-dropdown-item--notifications"
              (click)="openProfileTab('notifications')"
            >
              <i
                class="pi pi-bell user-dropdown-item-icon"
                aria-hidden="true"
              ></i>
              <span>Notifications</span>
            </button>
            <button
              class="user-dropdown-item user-dropdown-item--wishlist"
              (click)="openProfileTab('wishlist')"
            >
              <i
                class="pi pi-heart user-dropdown-item-icon"
                aria-hidden="true"
              ></i>
              <span>Your Wishlist</span>
            </button>
            <!-- <button class="user-dropdown-item user-dropdown-item--settings" (click)="openProfileTab('settings')">
              <span>âš™</span>
              <span class="user-dropdown-item-icon" aria-hidden="true"></span>
              <span>Account & Settings</span>
            </button> -->
            <button
              class="user-dropdown-item user-dropdown-item--logout"
              (click)="openLogoutModal()"
            >
              <i
                class="pi pi-sign-out user-dropdown-item-icon"
                aria-hidden="true"
              ></i>
              <span>Logout</span>
            </button>
          </div>
        </div>
      } @else {
        <button class="btn-primary" (click)="loginModalService.requestLogin()">
          Sign In
        </button>
      }
    </div>
  </div>
</header>

<!-- Mobile menu overlay & drawer -->
<div
  class="mobile-menu-overlay"
  [class.open]="mobileMenuOpen"
  (click)="closeMobileMenu()"
  aria-hidden="true"
></div>
<nav
  class="mobile-menu-drawer"
  [class.open]="mobileMenuOpen"
  aria-label="Main navigation"
>
  <div class="mobile-menu-header">
    <span class="mobile-menu-title">Categories</span>
    <button
      class="mobile-menu-close"
      (click)="closeMobileMenu()"
      aria-label="Close menu"
    >
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M18 6L6 18M6 6L18 18"
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    </button>
  </div>
  <div class="mobile-menu-links">
    <button
      type="button"
      class="mobile-theme-toggle"
      (click)="toggleTheme(); closeMobileMenu()"
    >
      @if (isDarkMode) {
        Switch to Day Mode
      } @else {
        Switch to Night Mode
      }
    </button>
    @if (isLoggedIn) {
      <a
        href="/cart"
        class="mobile-menu-cart-link"
        (click)="openReviewFromCartClick($event); closeMobileMenu()"
        >My cart</a
      >
    }
    @for (item of headerNavItems; track item.label) {
      <a
        [href]="item.href || (item.kind === 'discover' ? '/' : '/discover')"
        [class.nav-active]="isNavItemActive(item)"
        (click)="onNavClick($event, item); closeMobileMenu()"
        >{{ item.label }}</a
      >
    }
  </div>
</nav>

<!-- Header Search Modal -->
<div
  class="header-search-overlay"
  [class.open]="searchModalOpen"
  (click)="onSearchModalClick($event)"
>
  <div
    class="header-search-modal"
    role="dialog"
    aria-modal="true"
    aria-label="Search events"
    (click)="$event.stopPropagation()"
  >
    <div class="header-search-top">
      <div class="header-search-input-wrap">
        <svg
          width="20"
          height="20"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          aria-hidden="true"
        >
          <circle
            cx="11"
            cy="11"
            r="6"
            stroke="currentColor"
            stroke-width="2"
          />
          <path
            d="M20 20L16.65 16.65"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
          />
        </svg>
        <input
          id="navbar-search-input"
          type="text"
          [(ngModel)]="navbarSearchQuery"
          (ngModelChange)="onNavbarSearchQueryChange($event)"
          placeholder="Search for Events, Artists, Venues..."
        />
      </div>

      <button
        type="button"
        class="header-search-close"
        (click)="closeSearchModal()"
        aria-label="Close search"
      >
        <svg
          width="22"
          height="22"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          aria-hidden="true"
        >
          <path
            d="M18 6L6 18M6 6L18 18"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      </button>
    </div>

    <div
      #searchTabsStrip
      class="header-search-tabs"
      role="tablist"
      aria-label="Search categories"
      (wheel)="onSearchTabsWheel($event)"
    >
      @for (tab of searchTabs; track tab) {
        <button
          type="button"
          class="header-search-tab"
          [class.active]="activeSearchTab === tab"
          (click)="setActiveSearchTab(tab)"
        >
          {{ tab }}
        </button>
      }
    </div>

    <div class="header-search-body">
      <div class="header-search-heading">
        {{ searchModalHeading }}
      </div>

      @if (isSearchModalLoading) {
        <div class="header-search-empty">Loading results...</div>
      } @else if (searchModalError) {
        <div class="header-search-empty">{{ searchModalError }}</div>
      } @else if (filteredSearchSuggestions.length) {
        <div class="header-search-results">
          @for (item of filteredSearchSuggestions; track item.id) {
            <div
              class="header-search-card"
              role="button"
              tabindex="0"
              (click)="onSearchResultClick(item)"
              (keydown)="onSearchResultKeydown($event, item)"
            >
              <div
                class="header-search-card-thumb"
                [style.background]="item.thumbnailGradient"
              >
                @if (item.thumbnailImage) {
                  <img
                    class="header-search-card-thumb-image"
                    [src]="item.thumbnailImage"
                    [alt]="item.title"
                  />
                } @else {
                  <span>{{ item.thumbnailLabel }}</span>
                }
              </div>

              <div class="header-search-card-content">
                <div class="header-search-card-title">{{ item.title }}</div>
                <div class="header-search-card-meta">
                  <span class="header-search-card-line">
                    <svg
                      width="14"
                      height="14"
                      viewBox="0 0 24 24"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                      aria-hidden="true"
                    >
                      <path
                        d="M21 10C21 17 12 23 12 23S3 17 3 10C3 5.02944 7.02944 1 12 1C16.9706 1 21 5.02944 21 10Z"
                        stroke="#ff4d88"
                        stroke-width="2"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                      <circle
                        cx="12"
                        cy="10"
                        r="3"
                        stroke="currentColor"
                        stroke-width="2"
                      />
                    </svg>
                    {{ item.city }}
                  </span>
                  <span class="header-search-card-line">
                    <svg
                      width="14"
                      height="14"
                      viewBox="0 0 24 24"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                      aria-hidden="true"
                    >
                      <rect
                        x="3"
                        y="5"
                        width="18"
                        height="16"
                        rx="2"
                        stroke="#ff4d88"
                        stroke-width="2"
                      />
                      <path
                        d="M16 3V7M8 3V7M3 11H21"
                        stroke="currentColor"
                        stroke-width="2"
                        stroke-linecap="round"
                      />
                    </svg>
                    {{ item.date }} · {{ item.time }}
                  </span>
                </div>
              </div>

              <button
                type="button"
                class="header-search-card-fav"
                [class.is-active]="isSearchResultWishlisted(item)"
                [attr.aria-label]="
                  isSearchResultWishlisted(item)
                    ? 'Remove event from wishlist'
                    : 'Save event'
                "
                [attr.aria-pressed]="isSearchResultWishlisted(item)"
                (click)="
                  !['sold out', 'completed', 'cancelled'].includes(
                    item.event_status.toLowerCase()
                  ) && onSearchWishlistClick(item, $event)
                "
                [ngStyle]="{
                  cursor: ['sold out', 'completed', 'cancelled'].includes(
                    item.event_status.toLowerCase()
                  )
                    ? 'not-allowed'
                    : 'pointer',
                }"
              >
                <svg
                  width="20"
                  height="20"
                  viewBox="0 0 24 24"
                  [attr.fill]="
                    isSearchResultWishlisted(item) ? '#ff4d88' : 'none'
                  "
                  xmlns="http://www.w3.org/2000/svg"
                  color="#ff4d79"
                >
                  <path
                    d="M12.001 21C11.7097 21 11.4294 20.8942 11.2102 20.7024C9.76148 19.4376 8.37835 18.2562 7.21469 17.2624C3.81269 14.3568 2 12.8088 2 9.9096C2 7.5684 3.82951 5.8 6.18888 5.8C7.53422 5.8 8.82687 6.4212 9.66473 7.4796C10.5026 6.4212 11.7952 5.8 13.1406 5.8C15.5 5.8 17.3295 7.5684 17.3295 9.9096C17.3295 12.8088 15.5168 14.3568 12.1148 17.2624C11.9511 17.4024 11.7817 17.5472 11.6074 17.6964"
                    stroke="currentColor"
                    stroke-width="1.8"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
              </button>
            </div>
          }
        </div>
      } @else {
        <div class="header-search-empty">No Events Found.</div>
      }
    </div>
  </div>
</div>

<!-- Login Modal -->
<div
  class="login-modal-overlay"
  [class.open]="loginModalOpen"
  (click)="onModalClick($event)"
>
  <div class="login-modal" (click)="$event.stopPropagation()">
    <button class="modal-close" (click)="closeLoginModal()">
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M18 6L6 18M6 6L18 18"
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    </button>

    <div class="modal-content">
      <div class="modal-logo">
        <img
          [src]="
            isDarkMode
              ? 'assets/images/LIVEPASS-w.png'
              : 'assets/images/LIVEPASS-b.png'
          "
          alt=""
          class="modal-logo-img"
          width="160"
          height="36"
        />
      </div>

      @if (loginModalStep === "mobile") {
        @if (!otpSent) {
          <h2 class="modal-title">Sign In</h2>
          <p class="modal-subtitle">Enter your mobile number to receive OTP</p>

          <div class="modal-form">
            <div class="input-group">
              <label for="mobile">Mobile Number</label>
              <div class="input-wrapper">
                <select
                  class="country-code"
                  aria-label="Country calling code"
                  [(ngModel)]="selectedCountryId"
                  (ngModelChange)="onCountryCodeChange()"
                  [disabled]="isLoading"
                >
                  @for (country of countryCodeOptions; track country.id) {
                    <option [ngValue]="country.id">{{ country.name }} ({{ country.dialCode }})</option>
                  }
                </select>
                <input
                  type="tel"
                  id="mobile"
                  [ngModel]="mobileNumber"
                  (ngModelChange)="onMobileNumberInput($event)"
                  placeholder="Enter mobile number"
                  inputmode="numeric"
                  pattern="[0-9]*"
                  (keydown)="onMobileNumberKeyDown($event)"
                  (keyup.enter)="sendOtp()"
                  [disabled]="isLoading"
                />
              </div>
            </div>

            @if (errorMessage) {
              <div class="error-message">
                <svg
                  width="16"
                  height="16"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <circle
                    cx="12"
                    cy="12"
                    r="10"
                    stroke="currentColor"
                    stroke-width="2"
                  />
                  <path
                    d="M12 8V12M12 16H12.01"
                    stroke="currentColor"
                    stroke-width="2"
                    stroke-linecap="round"
                  />
                </svg>
                <span>{{ errorMessage }}</span>
              </div>
            }

            @if (successMessage) {
              <div class="success-message">
                <svg
                  width="16"
                  height="16"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M20 6L9 17L4 12"
                    stroke="currentColor"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
                <span>{{ successMessage }}</span>
              </div>
            }

            <button
              type="button"
              class="modal-submit-btn"
              (click)="sendOtp()"
              [disabled]="
                isLoading || !isMobileNumberValid
              "
            >
              @if (isLoading) {
                <span class="spinner"></span>
                <span>Sending OTP...</span>
              } @else {
                Send OTP
              }
            </button>

            <!-- <div class="login-alt-method">
              <button type="button" class="login-alt-method-btn" (click)="switchToEmailLogin()">
                Sign in with email
              </button>
            </div> -->

            <p class="modal-footer">
              By continuing, you agree to our
              <a href="/terms" (click)="openLegalFromModal('/terms', $event)"
                >Terms and Conditions</a
              >
              and
              <a
                href="/privacy"
                (click)="openLegalFromModal('/privacy', $event)"
                >Privacy Policy</a
              >.
            </p>
          </div>
        } @else {
          <h2 class="modal-title">Verify OTP</h2>
          <p class="modal-subtitle">
            Enter the 4-digit OTP sent to {{ selectedCountryCode }} {{ mobileNumber }}
          </p>

          <div class="modal-form">
            <div class="otp-container">
              @for (i of otpIndices; track i) {
                <input
                  type="tel"
                  class="otp-input"
                  [(ngModel)]="otpDigits[i]"
                  (input)="onOtpInput(i, $event)"
                  (keydown)="onOtpKeyDown(i, $event)"
                  maxlength="1"
                  [disabled]="isLoading || otpExpired"
                />
              }
            </div>

            @if (otpTimer > 0) {
              <div class="otp-timer">
                <span
                  >OTP expires in:
                  <strong>{{ formatTimer(otpTimer) }}</strong></span
                >
              </div>
            }

            @if (otpExpired && otpTimer <= 0) {
              <div class="error-message otp-expired-hint" role="alert">
                <svg
                  width="16"
                  height="16"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <circle
                    cx="12"
                    cy="12"
                    r="10"
                    stroke="currentColor"
                    stroke-width="2"
                  />
                  <path
                    d="M12 8V12M12 16H12.01"
                    stroke="currentColor"
                    stroke-width="2"
                    stroke-linecap="round"
                  />
                </svg>
                <span
                  >OTP expired. Tap <strong>Resend OTP</strong> to get a new
                  code.</span
                >
              </div>
            }

            @if (errorMessage) {
              <div class="error-message">
                <svg
                  width="16"
                  height="16"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <circle
                    cx="12"
                    cy="12"
                    r="10"
                    stroke="currentColor"
                    stroke-width="2"
                  />
                  <path
                    d="M12 8V12M12 16H12.01"
                    stroke="currentColor"
                    stroke-width="2"
                    stroke-linecap="round"
                  />
                </svg>
                <span>{{ errorMessage }}</span>
              </div>
            }

            @if (successMessage) {
              <div class="success-message">
                <svg
                  width="16"
                  height="16"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M20 6L9 17L4 12"
                    stroke="currentColor"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
                <span>{{ successMessage }}</span>
              </div>
            }

            <button
              class="modal-submit-btn"
              (click)="verifyOtp()"
              [disabled]="
                isLoading || otpExpired || otpDigits.join('').length !== 4
              "
            >
              @if (isLoading) {
                <span class="spinner"></span>
                <span>Verifying OTP...</span>
              } @else {
                Verify OTP
              }
            </button>

            <div class="otp-actions">
              <button
                type="button"
                class="resend-btn"
                (click)="resendOtp()"
                [disabled]="otpTimer > 0"
              >
                @if (otpTimer > 0) {
                  Resend OTP in {{ formatTimer(otpTimer) }}
                } @else {
                  Resend OTP
                }
              </button>
              <button
                type="button"
                class="change-number-btn"
                (click)="changeMobileNumber()"
              >
                Change Mobile Number
              </button>
              <!-- <button type="button" class="login-alt-method-btn login-alt-method-btn-block" (click)="switchToEmailLogin()">
                Sign in with email
              </button> -->
            </div>

            <p class="modal-footer">
              By continuing, you agree to our
              <a href="/terms" (click)="openLegalFromModal('/terms', $event)"
                >Terms and Conditions</a
              >
              and
              <a
                href="/privacy"
                (click)="openLegalFromModal('/privacy', $event)"
                >Privacy Policy</a
              >.
            </p>
          </div>
        }
      }

      @if (loginModalStep === "email") {
        <h2 class="modal-title">Sign in with email</h2>
        <p class="modal-subtitle">
          Enter the email and password for your account
        </p>

        <div class="modal-form">
          <div class="input-group">
            <label for="login-email">Email</label>
            <div class="input-wrapper input-wrapper-full">
              <input
                type="email"
                id="login-email"
                name="loginEmail"
                [(ngModel)]="loginEmail"
                placeholder="you@example.com"
                autocomplete="email"
                [disabled]="isLoading"
                (keyup.enter)="signInWithEmail()"
              />
            </div>
          </div>

          <div class="input-group">
            <label for="login-password">Password</label>
            <div class="input-wrapper input-wrapper-full">
              <input
                type="password"
                id="login-password"
                name="loginPassword"
                [(ngModel)]="loginPassword"
                placeholder="Enter your password"
                autocomplete="current-password"
                [disabled]="isLoading"
                (keyup.enter)="signInWithEmail()"
              />
            </div>
          </div>

          @if (errorMessage) {
            <div class="error-message">
              <svg
                width="16"
                height="16"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <circle
                  cx="12"
                  cy="12"
                  r="10"
                  stroke="currentColor"
                  stroke-width="2"
                />
                <path
                  d="M12 8V12M12 16H12.01"
                  stroke="currentColor"
                  stroke-width="2"
                  stroke-linecap="round"
                />
              </svg>
              <span>{{ errorMessage }}</span>
            </div>
          }

          @if (successMessage) {
            <div class="success-message">
              <svg
                width="16"
                height="16"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M20 6L9 17L4 12"
                  stroke="currentColor"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
              <span>{{ successMessage }}</span>
            </div>
          }

          <button
            type="button"
            class="modal-submit-btn"
            (click)="signInWithEmail()"
            [disabled]="isLoading || !emailLooksValid() || !loginPassword"
          >
            @if (isLoading) {
              <span class="spinner"></span>
              <span>Signing in...</span>
            } @else {
              Sign In
            }
          </button>

          <div class="login-alt-method">
            <button
              type="button"
              class="login-alt-method-btn"
              [disabled]="isLoading"
              (click)="switchToMobileOtpLogin()"
            >
              Sign in with mobile OTP
            </button>
          </div>

          <p class="modal-footer">
            By continuing, you agree to our
            <a href="/terms" (click)="openLegalFromModal('/terms', $event)"
              >Terms and Conditions</a
            >
            and
            <a href="/privacy" (click)="openLegalFromModal('/privacy', $event)"
              >Privacy Policy</a
            >.
          </p>
        </div>
      }
    </div>
  </div>
</div>

<!-- Location updated modal (same UI as login modal) -->
<div
  class="login-modal-overlay"
  [class.open]="locationUpdateModalOpen"
  (click)="onLocationUpdateModalClick($event)"
  role="dialog"
  aria-modal="true"
  aria-labelledby="location-update-title"
>
  <div
    class="login-modal location-update-modal"
    (click)="$event.stopPropagation()"
  >
    <button
      type="button"
      class="modal-close"
      (click)="closeLocationUpdateModal()"
      aria-label="Close"
    >
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M18 6L6 18M6 6L18 18"
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    </button>

    <div class="modal-content">
      <div class="modal-logo">
        <img
          [src]="
            isDarkMode
              ? 'assets/images/LIVEPASS-w.png'
              : 'assets/images/LIVEPASS-b.png'
          "
          alt=""
          class="modal-logo-img"
          width="160"
          height="36"
        />
      </div>

      <h2 id="location-update-title" class="modal-title">Location updated</h2>
      <p class="modal-subtitle location-update-message">
        Your location is updated from
        <strong>{{ locationUpdateFrom }}</strong> to
        <strong>{{ locationUpdateTo }}</strong
        >.
      </p>

      <button
        type="button"
        class="modal-submit-btn"
        (click)="closeLocationUpdateModal()"
      >
        OK
      </button>
    </div>
  </div>
</div>

<!-- Logout confirmation modal (same style as login modal) -->
<div
  class="login-modal-overlay"
  [class.open]="logoutModalOpen"
  (click)="onLogoutModalClick($event)"
  role="dialog"
  aria-modal="true"
  aria-labelledby="logout-confirm-title"
>
  <div
    class="login-modal logout-confirm-modal"
    (click)="$event.stopPropagation()"
  >
    <button
      type="button"
      class="modal-close"
      (click)="closeLogoutModal()"
      aria-label="Close"
    >
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M18 6L6 18M6 6L18 18"
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    </button>

    <div class="modal-content logout-confirm-content">
      <div class="modal-logo">
        <img
          [src]="
            isDarkMode
              ? 'assets/images/LIVEPASS-w.png'
              : 'assets/images/LIVEPASS-b.png'
          "
          alt=""
          class="modal-logo-img"
          width="160"
          height="36"
        />
      </div>

      <h2 id="logout-confirm-title" class="modal-title">Logout</h2>
      <p class="modal-subtitle logout-confirm-subtitle">
        Are you sure you want to logout?
      </p>

      <div class="modal-form logout-confirm-actions">
        <button
          type="button"
          class="modal-cancel-btn"
          (click)="closeLogoutModal()"
          [disabled]="isLoading"
        >
          Cancel
        </button>
        <button
          type="button"
          class="modal-submit-btn"
          (click)="logout()"
          [disabled]="isLoading"
        >
          @if (isLoading) {
            <span class="spinner"></span>
            <span>Logging out...</span>
          } @else {
            Logout
          }
        </button>
      </div>
    </div>
  </div>
</div>

<!-- Toast for login and logout -->
<p-toast />
